import { Box } from '@/ui';
import { printVisibility } from '../../lib/printStyles';
import type { BackgroundProps } from './Background';
import type { Star as StarType } from './lib';
import { Stars } from './Stars';

type Props = BackgroundProps & {
  stars?: StarType[];
};

export const ColorBackground = ({ stars }: Props) => {
  return (
    <Box
      bg="var(--experience-page-background)"
      inset="0"
      pointerEvents="none"
      pos="fixed"
      sx={printVisibility.hide()}
      zIndex={-1}
    >
      <Stars starsOverride={stars} />
    </Box>
  );
};
